import ConfirmPayment from '@frontend/features/confirm-payment/ConfirmPayment'

import OmisePromptpayScan from '../../checkout/components/OmisePromptpayScan'
import { PaymentMethodEnum } from '../../checkout/libs/type'
import { type Order, OrderStatusEnum } from '../libs/type'

interface OrderDetailProps {
  order: Order
}

export function PaymentDetail({ order }: Readonly<OrderDetailProps>) {
  switch (order.paymentMethod) {
    case PaymentMethodEnum.BACS:
      if (
        order.status === OrderStatusEnum.ON_HOLD ||
        order.status === OrderStatusEnum.PENDING
      ) {
        return <ConfirmPayment orderId={order.orderId} />
      }
      return <></>
    case PaymentMethodEnum.OMISE_PROMPTPAY:
      if (
        order.status === OrderStatusEnum.ON_HOLD ||
        order.status === OrderStatusEnum.PENDING
      ) {
        return <OmisePromptpayScan orderId={order.orderId} />
      }
      return <></>
    default:
      return <></>
  }
}

export default PaymentDetail
